/**
 * EntitySelector — dropdown for entities (consolidated vs individual).
 * Fetches from GET /api/v1/entities.
 */

import React, { useState, useEffect } from 'react';
import { BASE, authFetch } from '../constants';

interface Entity {
  entity_code: string;
  entity_name: string;
  country?: string;
  functional_currency?: string;
}

interface EntitySelectorProps {
  value: string;
  onChange: (entityCode: string) => void;
}

export const EntitySelector: React.FC<EntitySelectorProps> = ({ value, onChange }) => {
  const [entities, setEntities] = useState<Entity[]>([]);

  useEffect(() => {
    authFetch(`${BASE}/api/v1/entities`)
      .then(r => r.json())
      .then(data => {
        const list = data?.entities || data || [];
        if (Array.isArray(list)) setEntities(list);
      })
      .catch(() => {});
  }, []);

  return (
    <select
      value={value}
      onChange={e => onChange(e.target.value)}
      style={{
        background: 'var(--bg-elevated, var(--bg-elevated))',
        color: 'var(--text-primary, #F0F2F5)',
        border: '1px solid var(--border-subtle, rgba(0,0,0,0.06))',
        borderRadius: 'var(--radius-sm, 6px)',
        padding: '6px 10px',
        fontSize: '12px',
        fontFamily: "var(--font-body, var(--font-sans))",
        cursor: 'pointer',
        outline: 'none',
      }}
    >
      <option value="*">All Entities</option>
      {entities.map(e => (
        <option key={e.entity_code} value={e.entity_code}>
          {e.entity_code} — {e.entity_name}
        </option>
      ))}
    </select>
  );
};

export default EntitySelector;
